import countryService from "../../services/country.service";


    export const state ={
        cities:[],
        states:[],

    }
    export const actions = {
        fetch_cities({commit}, page){
            return countryService.get_cities(page).then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_CITIES', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    // commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        fetch_totals({commit},){
            return  countryService.fetch_totals().then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_TOTALS', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },

    }
    export const mutations = {
        
        SET_CITIES(state,payload){
            state.states = payload.states,
            state.cities = payload.cities.data
        },
        SET_TOTALS(state,totals){
            state.totals = totals
        },
       
    }
    export const getters = {
        get_cities(state){
            return state.cities
        },
        get_states(state){
            return state.states
        },
        

    }


